<template>
  <a-config-provider :locale="locale">
    <router-view/>
  </a-config-provider>
</template>

<script>
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
dayjs.locale('zh');

export default {
  components: {

  },
  data() {
    return {
      locale: zhCN,
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    
  }
}
</script>

<style lang="less">

</style>
